var render = function render(){var _vm=this,_c=_vm._self._c,_setup=_vm._self._setupProxy;return (_vm.validTrack && _vm.validTime)?_c('div',{staticClass:"bg-black bg-opacity-90 px-2 py-0.5 rounded text-center"},[_vm._v("\n  "+_vm._s(_vm.subtitle?.text ?? '')+"\n")]):_vm._e()
}
var staticRenderFns = []

export { render, staticRenderFns }